module.exports = __webpack_public_path__ + "img/dots-grid.30236bbf.svg";